import React, { useEffect, useState } from 'react'
import { Progress } from 'antd'
import { ReactComponent as CloseIcon } from 'assets/svg/shared/close.svg'
import { WhitelabelConfig } from 'hooks'

export const Alert = ({ message, isTimeOut, closeAction }) => {
    const [progress, setProgress] = useState(100)

    useEffect(() => {
        if (isTimeOut) {
            const interval = setInterval(() => setProgress((val) => (val > 0 ? val - 1 : 0)), 50)
            return () => clearInterval(interval)
        }
    }, [isTimeOut])

    useEffect(() => {
        progress === 0 && closeAction()
    }, [progress, closeAction])

    return (
        <div className={`alert--custom ${isTimeOut ? 'alert--progress' : ''}`}>
            <div className="alert__content">
                <p className="alert__text">{message}</p>
                <button type="button" className="alert__btn" onClick={closeAction}>
                    <CloseIcon />
                </button>
            </div>

            {isTimeOut && (
                <div className="alert__progress">
                    <Progress
                        percent={progress}
                        showInfo={false}
                        strokeColor={WhitelabelConfig.colors.primary}
                        trailColor="transparent"
                        strokeWidth={6}
                    />
                </div>
            )}
        </div>
    )
}
